const tryToFocus = (element: HTMLElement): boolean => {
  if (
    element.tabIndex >= 0 ||
    element.isContentEditable ||
    element instanceof HTMLAnchorElement ||
    element instanceof HTMLButtonElement ||
    element instanceof HTMLInputElement ||
    element instanceof HTMLSelectElement ||
    element instanceof HTMLTextAreaElement
  ) {
    element.focus();
    return true;
  }

  return false;
};

/**
 *
 *
 *
 *
 */
export const focusDeepWithin = (element: HTMLElement): boolean => {
  return (
    element instanceof HTMLSlotElement
      ? element.assignedElements()
      : Array.from((element.shadowRoot ?? element).children)
  )
    .filter((ele) => ele instanceof HTMLElement)
    .some((ele) => tryToFocus(ele) || focusDeepWithin(ele));
};
